// extracted by mini-css-extract-plugin
export var enter = "Background-module--enter--Bb7ZD";
export var img = "Background-module--img--0lQaB";
export var plane = "Background-module--plane--d8EO-";
export var wrapper = "Background-module--wrapper--RIYX0";